
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termsOfService.html",
      function () {
        return require("private-next-pages/termsOfService.html.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termsOfService.html"])
      });
    }
  